import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ArticlesComponent } from '../../../articles/articles.component';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { combineLatest, filter, take } from 'rxjs';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { User } from 'src/app/shareModule/models/user.model';
import { AppState } from 'src/app/shareModule/states/app.state';
import { RecommandationsFormComponent } from '../../../../community/recommandations-form/recommandations-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-news-me',
  templateUrl: './news-me.component.html',
  styleUrls: ['./news-me.component.scss'],
})
export class NewsMeComponent {
  @ViewChild('communityArticles') communityArticles: ArticlesComponent;
  viewGrid: boolean = true;
  carousel: any = {
    slidesPerView: 2,
  };
  userId: any = null;

  constructor(
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private customerService: CustomerService,
    public roleService: RoleService,
    private store: Store<AppState>,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }


  carouselOptions: any = {
    slidesPerView: 2,
    grid: {
      rows: 1,
      fill: 'row',
    },
    spaceBetween: 10,
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
    },
  };

  catsCount: any = []
  ngOnInit(): void {
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
      this.userId = r?.id
      if (r?.regionName) {
        this.auth.getCountsOfRecommendationCategoriestInSubRegion(r.region).subscribe({
          next: (data: any) => {
            this.catsCount = data.data.filter(cat => cat.recommendationCounts && cat.name?.trim());
            this.catsCount.forEach(cat => cat.selected = true)
            this.fetchRecommdations()
          },
          error: (err) => {
            console.error(err);
            this.toastr.error("Something went wrong while fetching counts")
          }
        })
        //this._getMemberShopProduct(); 

      }
      this.communityArticles.getArticlesList(1, '', r?.regionName);
    });
  }



  openShopPopup(name) {
    this.sharedService.triggerInitTabProfile('loudspeaker');
    setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(name);
    }, 100);
  }



  public openAddRecommendationForm() {


    const s = this.modalService.open(RecommandationsFormComponent)
    s.hidden.subscribe({
      next: () => {
        this.fetchRecommdations();

      }
    });

  }

  public myRecommendations = []
  recommendations: any = []
  imageUrl: string = environment.ImageUrl
  private fetchRecommdations() {
    this.auth.getallrecommendations({
      categries: this.catsCount.filter(cat => cat.selected).map(cat => cat.id)
    })
      .subscribe({
        next: (data: any) => {
          this.recommendations = data.data;
          this.myRecommendations = Array.from(this.recommendations.filter(recommemdation => recommemdation.memberId == this.userId))
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Error while fetching recommendations")
        }
      })
  }


  public like(recomm) {
    this.auth.toggleRecommendationReaction(recomm.id)
      .subscribe({
        next: (data) => {
          recomm.haveILiked = !recomm.haveILiked
          if (recomm.haveILiked) {
            recomm.likeCounts += 1
          } else {
            recomm.likeCounts -= 1
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Unable to like please try again latter")
        }
      })
  }
}
